/* src/app/common/components/button-group/button-group.component.scss */
:host {
  display: inline-block;
}
:host ::ng-deep ion-button {
  margin: 0 !important;
  --border-radius: 0;
}
:host ::ng-deep ion-button ~ ion-button {
  --border-width: 1px 1px 1px 0;
}
:host ::ng-deep ion-button:first-child {
  --border-radius: 3px 0 0 3px;
}
:host ::ng-deep ion-button:last-child {
  --border-radius: 0 3px 3px 0;
}
:host ::ng-deep ion-button.active {
  --background: rgba(var(--ion-color-primary-rgb), 10%);
  --border-color: var(--ion-color-primary);
}
/*# sourceMappingURL=button-group.component.css.map */
